module.exports = __webpack_public_path__ + "img/new_03_1.142219a3.jpg";